import { useRequest } from 'loti-request';

import { getApiUrl } from 'app/utils/api';

const useReadmeRequest = (project: string) =>
  useRequest<{ url: string }>({
    url: getApiUrl(`/users/documentation_url?project=${project}`)
  });

const openInNewtab = (url: string) => {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
  if (newWindow) newWindow.opener = null;
};

const openInSameTab = (url: string) => {
  window.location.replace(url);
};

export { useReadmeRequest, openInNewtab, openInSameTab };
